<template>
  <my-dialog ref="editForm" title="创建订单" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
    @close="closeDialog" width="80%">
    <div class="main_bg">
      <div class="item_info border_Warningcolor">
        <el-descriptions class="margin-top" title="订单信息" :column="3" border>
          <template slot="extra">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="GenerateOrderNumber">获取单号</el-button>
          </template>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              订单号
            </template>
            <el-input v-model="editForm.orderNo" style="width: 100%" placeholder="请输入订单号" disabled />
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              所属门店 </template><el-select v-model="editForm.belongStoreKeyId" placeholder="请选择门店" clearable
              style="width: 100%" @change="handleSelectStore">
              <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                :key="item.keyId"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              取镜时间
            </template>
            <el-date-picker v-model="editForm.getOrderDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
              style="width: 100%">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              验光师
            </template>
            <el-input v-model="editForm.yanGuangShi" style="width: 100%" placeholder="请输入验光师" />
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              镜架信息
            </template>
            <el-input v-model="editForm.jjInformation" style="width: 100%" placeholder="请输入镜架信息" />
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              加工类型
            </template>
            <el-radio-group v-model.number="editForm.machinType">
              <el-radio-button v-for="item in machinTypeList" :label="item.code" :key="item.code" :value="item.code">{{
                item.name
                }}</el-radio-button>
            </el-radio-group>
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              备注
            </template>
            <el-input v-model="editForm.remark" style="width: 100%" placeholder="请输入备注" />
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="item_info">
        <el-descriptions class="margin-top" title="顾客信息" :column="6" border>
          <template slot="extra">
            <el-button type="primary" size="small" icon="el-icon-search"
              @click="showSelectCustomerDialog">选择顾客</el-button>
          </template>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              顾客姓名
            </template>
            {{ transformEmpty(customerInfo.name) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-office-building"></i>
              性别
            </template>
            {{ transformGender(customerInfo.gender) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              年龄
            </template>
            {{ transformEmpty(customerInfo.age) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              顾客电话
            </template>
            {{ transformEmpty(customerInfo.phone) }}
          </el-descriptions-item>
          <el-descriptions-item span="3">
            <template slot="label">
              <i class="el-icon-location-outline"></i>
              所属门店
            </template>
            {{ transformEmpty(customerInfo.belongStoreName) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              (右眼)球镜
            </template>
            {{ transformEmpty(customerInfo.rParams.qiuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              柱镜
            </template>
            {{ transformEmpty(customerInfo.rParams.zhuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              轴位
            </template>
            {{ transformEmpty(customerInfo.rParams.zhouWei) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              矫正视力
            </template>
            {{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳距
            </template>
            {{ transformEmpty(customerInfo.rParams.tongJu) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳高
            </template>
            {{ transformEmpty(customerInfo.rParams.tongGao) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              (左眼)球镜
            </template>
            {{ transformEmpty(customerInfo.lParams.qiuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              柱镜
            </template>
            {{ transformEmpty(customerInfo.lParams.zhuJing) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              轴位
            </template>
            {{ transformEmpty(customerInfo.lParams.zhouWei) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              矫正视力
            </template>
            {{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳距
            </template>
            {{ transformEmpty(customerInfo.lParams.tongJu) }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-tickets"></i>
              瞳高
            </template>
            {{ transformEmpty(customerInfo.lParams.tongGao) }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="item_info border_Green">
        <div class="item_title">
          <div class="title">商品信息</div>
          <div class="btnDiv">
            <!-- <el-button
              type="primary"
              size="small"
              icon="el-icon-plus"
              @click="showSelectGoodsDialogCreate"
              >添加商品</el-button 
            >-->
            订单来源：
            <el-select v-model.number="editForm.orderSource" placeholder="请选择订单来源" clearable size="small">
              <el-option v-for="item in orderSourceList" :label="item.name" :value="item.code"
                :key="item.code"></el-option>
            </el-select>
            镜片类型：
            <el-select v-model.number="editForm.eyeGlassType" placeholder="请选择镜片类型" clearable size="small">
              <el-option v-for="item in eyeGlassTypeList" :label="item.name" :value="item.code"
                :key="item.code"></el-option>
            </el-select>
          </div>
        </div>
        <el-table :data="goodsTableData" style="width: 100%" border
          :header-cell-style="{ textAlign: 'center', borderColor: '#333' }"
          :cell-style="{ textAlign: 'center', borderColor: '#333' }">
          <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
          <el-table-column prop="lR" label="左右眼" width="100">
            <template slot-scope="scope">
              <el-select v-model="scope.row.lR" placeholder="请选择" size="small" disabled>
                <el-option label="右眼" key="0" :value="0"></el-option>
                <el-option label="左眼" key="1" :value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="商品品牌" width="120"></el-table-column>
          <el-table-column prop="name" label="商品名称"> </el-table-column>
          <el-table-column prop="qiuJing" label="球镜" width="80">
          </el-table-column>
          <el-table-column prop="zhuJing" label="柱镜" width="80">
          </el-table-column>
          <el-table-column prop="zhouWei" label="轴位" width="120">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.zhouWei" placeholder="请输入轴位" size="small" min="0" max="180" step="1"
                type="number" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="price" label="单价" width="100">
            <template slot-scope="scope">
              <el-input
                v-model.number="scope.row.price"
                type="number"
                placeholder="请输入单价"
                size="small"
                :min="0"
              ></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="quantity" label="数量" width="155">
            <template slot-scope="scope">
              <el-input-number v-model.number="scope.row.quantity" placeholder="请输入数量" size="small" :min="0"
                :step="1"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="80">
          </el-table-column>
          <!-- <el-table-column prop="money" label="总价" width="100">
            <template slot-scope="scope">
              <el-input
                v-model.number="scope.row.money"
                placeholder="请输入总价"
                size="small"
                :min="0"
              ></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="remark" label="ADD">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" placeholder="请输入ADD" size="small"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="small" icon="el-icon-plus"
                @click="showSelectGoodsDialogCreate(scope.row.lR)">添加商品</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button size="small" type="primary" :loading="saveloading" class="title" @click="submitForm()">
        保存
      </el-button>
    </div>
  </my-dialog>
</template>
<script>
import { GenerateOrderNumber, CreateStoreOrder } from "@/api/storeOrderApi.js";
import { getCustomerInfoDetail } from "@/api/baseDataApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
export default {
  props: [],
  data() {
    return {
      showDialog: false,
      saveloading: false,
      editForm: {
        belongStoreKeyId: "",
        orderNo: "",
        getOrderDate: "",
        jjInformation: "",
        customerKeyId: "",
        yanGuangShi: "",
        machinType: 0,
        remark: "",
        eyeGlassType: 0,
        orderSource: 1,
      },
      goodsKeyIds: [],
      rules: {},
      isEdit: false,
      storeList: [],
      customerInfo: {
        name: "",
        phone: "",
        age: "",
        gender: -1,
        belongStoreName: "",
        lParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
        rParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
      },
      goodsTableData: [
        {
          rowNumber: 1,
          lR: 0,
          zhouWei: 0,
          type: "",
          name: "",
          qiuJing: "",
          zhuJing: "",
          unit: "",
          quantity: 0,
          remark: "",
          goodsKeyId: "",
        },
        {
          rowNumber: 2,
          lR: 1,
          zhouWei: 0,
          type: "",
          name: "",
          qiuJing: "",
          zhuJing: "",
          unit: "",
          quantity: 0,
          remark: "",
          goodsKeyId: "",
        },
      ],
      goodsIndex: 1,
      machinTypeList: [],
      selectRowLR: 1,
      eyeGlassTypeList: [],
      orderSourceList: []
    };
  },
  computed: {},
  watch: {},
  components: {},
  created() {
    this.GetOrganizationListByConfig();
    this.getMachinType();
    this.getEyeGlassType();
    this.getOrderSource();
  },
  methods: {
    // 显示
    showCreateDialog() {
      this.showDialog = true;
      this.editForm = {
        belongStoreKeyId: "",
        orderNo: "",
        getOrderDate: "",
        jjInformation: "",
        customerKeyId: "",
        yanGuangShi: "",
        machinType: 0,
        remark: "",
      };
      this.goodsIndex = 1;
      this.goodsKeyIds = [];
    },
    // 点击保存
    submitForm() {
      let params = {
        belongStoreKeyId: this.editForm.belongStoreKeyId,
        orderNo: this.editForm.orderNo,
        getOrderDate: this.editForm.getOrderDate,
        jjInformation: this.editForm.jjInformation,
        customerKeyId: this.editForm.customerKeyId,
        yanGuangShi: this.editForm.yanGuangShi,
        machinType: this.editForm.machinType,
        remark: this.editForm.remark,
        eyeGlassType: this.editForm.eyeGlassType,
        orderSource: this.editForm.orderSource
      };
      if (
        params.belongStoreKeyId === "" ||
        params.belongStoreKeyId === null ||
        params.belongStoreKeyId === undefined
      ) {
        this.$message({
          type: "error",
          message: "请选择所属门店！",
        });
        return;
      }
      if (
        params.orderNo === "" ||
        params.orderNo === null ||
        params.orderNo === undefined
      ) {
        this.$message({
          type: "error",
          message: "请获取订单号！",
        });
        return;
      }
      if (
        params.getOrderDate === "" ||
        params.getOrderDate === null ||
        params.getOrderDate === undefined
      ) {
        this.$message({
          type: "error",
          message: "请选择取镜日期！",
        });
        return;
      }
      if (
        params.jjInformation === "" ||
        params.jjInformation === null ||
        params.jjInformation === undefined
      ) {
        this.$message({
          type: "error",
          message: "请输入镜架信息！",
        });
        return;
      }
      if (
        params.customerKeyId === "" ||
        params.customerKeyId === null ||
        params.customerKeyId === undefined
      ) {
        this.$message({
          type: "error",
          message: "请选择顾客！",
        });
        return;
      }
      if (
        params.yanGuangShi === "" ||
        params.yanGuangShi === null ||
        params.yanGuangShi === undefined
      ) {
        this.$message({
          type: "error",
          message: "请输入验光师！",
        });
        return;
      }
      if (
        params.machinType === "" ||
        params.machinType === null ||
        params.machinType === undefined ||
        params.machinType === 0
      ) {
        this.$message({
          type: "error",
          message: "请选择加工类型！",
        });
        return;
      }
      if (
        params.orderSource === "" ||
        params.orderSource === null ||
        params.orderSource === undefined ||
        params.orderSource === 0
      ) {
        this.$message({
          type: "error",
          message: "请选择订单来源！",
        });
        return;
      }
      if (
        params.eyeGlassType === "" ||
        params.eyeGlassType === null ||
        params.eyeGlassType === undefined ||
        params.eyeGlassType === 0
      ) {
        this.$message({
          type: "error",
          message: "请选择镜片类型！",
        });
        return;
      }
      if (!this.goodsTableData || this.goodsTableData.length === 0) {
        this.$message({
          type: "error",
          message: "请选择商品！",
        });
        return;
      }
      if (this.goodsTableData.length != 2) {
        this.$message({
          type: "error",
          message: "请选择2个商品！",
        });
        return;
      }
      if (
        this.goodsTableData[0].goodsKeyId === "" ||
        this.goodsTableData[0].goodsKeyId === undefined ||
        this.goodsTableData[0].goodsKeyId === "undefined"
      ) {
        this.$message({
          type: "error",
          message: "请选择商品！",
        });
        return;
      }
      if (
        this.goodsTableData[1].goodsKeyId === "" ||
        this.goodsTableData[1].goodsKeyId === undefined ||
        this.goodsTableData[1].goodsKeyId === "undefined"
      ) {
        this.$message({
          type: "error",
          message: "请选择商品！",
        });
        return;
      }
      //判断商品信息中的remark输入内容必须为数字，并且范围在0-400之间
      if (
        !/^[0-9]+$/.test(this.goodsTableData[0].remark) || !/^[0-9]+$/.test(this.goodsTableData[1].remark) ||
        parseInt(this.goodsTableData[0].remark) < 0 ||
        parseInt(this.goodsTableData[0].remark) > 400 ||
        parseInt(this.goodsTableData[1].remark) < 0 ||
        parseInt(this.goodsTableData[1].remark) > 400
      ) {
        this.$message({
          type: "error",
          message: "ADD必须为数字，并且范围在0-400之间！",
        });
        return;
      }
      // if (
      //   this.goodsTableData[0].quantity === 0 &&
      //   this.goodsTableData[1].quantity === 0
      // ) {
      //   this.$message({
      //     type: "error",
      //     message: "左右眼商品数量不能同时为0！",
      //   });
      //   return;
      // }
      params.dtls = this.goodsTableData;
      CreateStoreOrder(params).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: "订单创建成功！",
          });
          this.closeDialog();
          this.$parent.search();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 生成订单号
    GenerateOrderNumber() {
      GenerateOrderNumber({}).then((res) => {
        if (res.code == 1) {
          this.editForm.orderNo = res.data;
          this.$message.success("订单号获取成功！");
        } else {
          this.$message({
            type: "success",
            message: res.msg,
          });
        }
      });
    },
    // 获取所属门店
    GetOrganizationListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrganizationListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 选择门店
    handleSelectStore(val) {
      this.editForm.belongStoreKeyId = val;
    },
    // 选中顾客
    submitSelect(selectionKeyId) {
      this.editForm.customerKeyId = selectionKeyId;
      let params = {
        keyId: selectionKeyId,
      };
      getCustomerInfoDetail(params).then((res) => {
        if (res.code == 1) {
          this.customerInfo = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //转换性别
    transformGender(gender) {
      if (gender == 1) {
        return "男";
      } else if (gender == 0) {
        return "女";
      } else {
        return "--";
      }
    },
    // 关闭
    closeDialog() {
      this.$data.editForm = this.$options.data.call(this).editForm;
      this.goodsKeyIds = [];
      this.customerInfo = {
        name: "",
        phone: "",
        age: "",
        gender: -1,
        belongStoreName: "",
        lParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
        rParams: {
          qiuJing: "",
          zhuJing: "",
          zhouWei: 0,
          jiaoZhengShiLi: "",
          tongJu: "",
          tongGao: "",
        },
      };
      this.goodsIndex = 1;
      this.goodsTableData = [
        {
          rowNumber: 1,
          lR: 0,
          zhouWei: 0,
          type: "",
          name: "",
          qiuJing: "",
          zhuJing: "",
          unit: "",
          quantity: 0,
          remark: "",
          goodsKeyId: "",
        },
        {
          rowNumber: 2,
          lR: 1,
          zhouWei: 0,
          type: "",
          name: "",
          qiuJing: "",
          zhuJing: "",
          unit: "",
          quantity: 0,
          remark: "",
          goodsKeyId: "",
        },
      ];
      this.showDialog = false;
    },
    //判断为空则用 -- 替代
    transformEmpty(obj) {
      if (obj == "" || obj == null || obj == undefined) {
        obj = "--";
      }
      return obj;
    },
    // 展示选择顾客弹窗
    showSelectCustomerDialog() {
      this.$parent.showSelectCustomer();
    },
    // 展示选择商品弹窗
    showSelectGoodsDialogCreate(lr) {
      let paramsKeyId1 = "";
      let paramsKeyId2 = "";
      if (this.customerInfo) {
        if (lr === 0) {
          paramsKeyId1 = this.customerInfo.rParams.qiuJing;
          paramsKeyId2 = this.customerInfo.rParams.zhuJing;
        } else {
          paramsKeyId1 = this.customerInfo.lParams.qiuJing;
          paramsKeyId2 = this.customerInfo.lParams.zhuJing;
        }
      } else {
        this.$message({
          type: "error",
          message: "请选择顾客！",
        });
        return;
      }
      this.$parent.showSelectGoods(1, paramsKeyId1, paramsKeyId2);
      this.selectRowLR = lr;
    },
    // 选中商品
    submitSelectGoods(list) {
      let item = list[0];
      var info = {};
      info.rowNumber = this.selectRowLR === 1 ? 1 : 2;
      info.lR = this.selectRowLR;
      info.quantity = 1;
      // info.money = 0;
      // info.price = 0;
      info.name = item.name;
      info.type = item.type;
      info.unit = item.unit;
      info.qiuJing = item.qiuJing;
      info.zhuJing = item.zhuJing;
      info.goodsKeyId = item.keyId;
      info.remark = "";
      if (info.lR === 1) {
        info.zhouWei = parseInt(this.customerInfo.lParams.zhouWei);
      } else {
        info.zhouWei = parseInt(this.customerInfo.rParams.zhouWei);
      }
      this.$set(this.goodsTableData, this.selectRowLR, info);
    },
    // 获取加工类型
    getMachinType() {
      GetEnumConfigListByCode({
        code: "MachinType",
      })
        .then((res) => {
          if (res.code == 1) {
            this.machinTypeList = [];
            res.data.forEach(item => {
              this.machinTypeList.push({
                code: parseInt(item.code),
                name: item.name,
              })
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取加工类型失败!");
        });
    },
    // 获取镜片类型
    getEyeGlassType() {
      GetEnumConfigListByCode({
        code: "EyeGlassType",
      })
        .then((res) => {
          if (res.code == 1) {
            this.eyeGlassTypeList = [];
            res.data.forEach(item => {
              this.eyeGlassTypeList.push({
                code: parseInt(item.code),
                name: item.name,
              })
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取加工类型失败!");
        });
    },
    // 获取镜片类型
    getOrderSource() {
      GetEnumConfigListByCode({
        code: "StoreOrderSource",
      })
        .then((res) => {
          if (res.code == 1) {
            this.orderSourceList = [];
            res.data.forEach(item => {
              this.orderSourceList.push({
                code: parseInt(item.code),
                name: item.name,
              })
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("获取加工类型失败!");
        });
    },
  },
};
</script>
<style scoped lang="scss">
.main_bg {
  padding: 10px;
  margin-top: -15px;
}

.item_info {
  border-left: 5px solid #55aaff;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
  border-left: 5px solid #ff9900;
}

.border_Green {
  border-left: 5px solid #00cc66;
}

.item_title {
  display: flex;
  width: 100%;
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 10px;
  justify-content: space-between;

  .title {
    display: inline-block;
    unicode-bidi: isolate;
  }

  .btnDiv {
    display: block;
    unicode-bidi: isolate;
    word-break: break-all;
  }
}
</style>